import React, { useState, useEffect } from 'react';
import './Modal.css';

export function AdminPasswordModal({ visible, onClose, onSubmit }) {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (visible) {
      setPassword('');
      setIsLoading(false);
      setErrorMessage('');
    }
  }, [visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    
    setIsLoading(true);
    setErrorMessage('');
    
    try {
      await onSubmit(password);
    } catch (error) {
      setErrorMessage(error.message || '로그인에 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  if (!visible) return null;

  return (
    <div className="modern-modal-overlay admin-modal-overlay">
      <div className="modern-modal-container admin-modal-container">
        <div className="modern-modal-content">
          {/* Modal Header */}
          <div className="modal-header-section admin-modal-header">
            <div className="modal-title-area">
              <h2 className="modal-title">
                <i className="fas fa-shield-alt me-3"></i>
                관리자 인증
              </h2>
              <p className="modal-subtitle">관리자 권한으로 접속하려면 비밀번호를 입력해주세요</p>
            </div>
            <button 
              className="modal-close-btn" 
              onClick={onClose}
              disabled={isLoading}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          {/* Modal Body */}
          <div className="modal-body-section admin-modal-body">
            <form onSubmit={handleSubmit} className="admin-password-form">
              {errorMessage && (
                <div className="admin-message error">
                  <i className="fas fa-exclamation-triangle"></i>
                  {errorMessage}
                </div>
              )}
              
              <div className="password-input-group">
                <label className="password-label">
                  <i className="fas fa-key me-2"></i>
                  관리자 비밀번호
                </label>
                <div className="password-input-container">
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="비밀번호를 입력하세요"
                    className="password-input"
                    autoFocus
                    disabled={isLoading}
                  />
                  <i className="fas fa-lock password-icon"></i>
                </div>
              </div>

              <div className="admin-modal-actions">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  <i className="fas fa-times me-2"></i>
                  취소
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isLoading || !password.trim()}
                >
                  {isLoading ? (
                    <>
                      <i className="fas fa-spinner fa-spin me-2"></i>
                      인증 중...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-sign-in-alt me-2"></i>
                      로그인
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
} 